import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login'
import Home from '@/views/home'
import Volunteeractivity from '@/views/volunteeractivity'
import Myvolunteeractivity from '@/views/myvolunteeractivity'
import Activitydetail from '@/views/activitydetail'
import Volunteerinfo from '@/views/volunteerinfo'
import Volunteermuseum from '@/views/volunteermuseum'
import Volunteerinfomuseumedit from '@/views/volunteerinfomuseumedit'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/volunteer'
    },
    {
      path: '/volunteer',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/volunteerinfo',
      name: 'volunteerinfo',
      component: Volunteerinfo
    },
    {
      path: '/volunteermuseum',
      name: 'volunteermuseum',
      component: Volunteermuseum
    },
    {
      path: '/volunteeractivity',
      name: 'volunteeractivity',
      component: Volunteeractivity
    },
    {
      path: '/myvolunteeractivity',
      name: 'myvolunteeractivity',
      component: Myvolunteeractivity
    },
    {
      path: '/activitydetail/:id',
      name: 'activitydetail',
      component: Activitydetail
    },
    {
      path: '/volunteerinfomuseumedit',
      name: 'volunteerinfomuseumedit',
      component: Volunteerinfomuseumedit
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js